<template>
    <el-container style="height: 90%; border: 1px solid #eee">
        <el-aside width="200px" style="background-color: rgb(238, 241, 246)">
            <el-menu default-active="1">
                <el-menu-item index="1" @click="searchClothesDictionary(1)">
                    <template slot="title"><i class="el-icon-paperclip"></i>服装款式</template>
                </el-menu-item>
                <el-menu-item  index="2" @click="searchClothesDictionary(2)">
                    <template slot="title"><i class="el-icon-tickets"></i>服装材质</template>
                </el-menu-item >
                <el-menu-item  index="3" @click="searchClothesDictionary(3)">
                    <template slot="title"><i class="el-icon-user"></i>品牌商</template>
                </el-menu-item >
                <el-menu-item  index="4" @click="searchClothesDictionary(4)">
                    <template slot="title"><i class="el-icon-user"></i>尺码</template>
                </el-menu-item >
            </el-menu>
        </el-aside>
        <el-container>
            <el-header height="50px">
               <el-row :gutter="10">
                        <el-col :span="1.5">
                            <div class="grid-content bg-purple">
                                <span>关键字:</span>
                            </div>
                        </el-col>
                        <el-col :span="5"
                            ><div class="grid-content bg-purple">
                                <el-input v-model="searchInfo.dicName"  placeholder="请输入关键字" clearable></el-input></div
                        ></el-col>
                        <el-col :span="10">
                            <el-button type="primary" icon="el-icon-search" @click="search()">查询</el-button>
                            <el-button type="primary" icon="el-icon-plus" @click="openDialog()">新增</el-button>
                        </el-col>
                    </el-row>
            </el-header>
            <el-main>
                <el-table :data="tableData" border>
                    <el-table-column prop="date" label="序号" width="100" align="center">
                        <template slot-scope="scope">{{ scope.$index + 1 + searchInfo.pageSize * (searchInfo.pageNum - 1) }}</template>
                    </el-table-column>
                    <el-table-column prop="dicName" :label="this.tableIndex == 1 ? '服装款式' : this.tableIndex == 2 ? '材质概述' : this.tableIndex == 3 ? '品牌商' : '尺码'" align="center"></el-table-column>
                    <el-table-column prop="dicCode" :label="this.tableIndex == 1 ? '款式代码' : this.tableIndex == 2 ? '材质代码' : this.tableIndex == 3 ? '品牌商代码' : '尺码排序'"  align="center"></el-table-column>
                    <el-table-column prop="createTime" label="添加时间"  align="center">
                        <template slot-scope="scope">
                            <span>{{ scope.row.createTime | moment('YYYY-MM-DD HH:mm:ss') }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="inUse" label="是否启用"  align="center" >
                        <template slot-scope="scope">
                            <el-switch
                                v-model="scope.row.inUse"
                                :active-value="1" 
	                            :inactive-value="0" 
                                @change="changeInUse(scope.row.id)"
                                active-color="#13ce66"
                                inactive-color="#ff4949">
                            </el-switch>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" :resizable="false" align="center">
                            <template slot-scope="scope">
                                <el-button type="text" size="small" @click="deleteClothesDictionary(scope.row.id)">删除</el-button>
                            </template>
                        </el-table-column>
                </el-table>
            </el-main>
            <el-footer>
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="searchInfo.pageNum"
                        :page-size="searchInfo.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                    ></el-pagination>
            </el-footer>
            <div>
                <el-dialog title="新增配置" :visible.sync="addDialogVisible" width="33%" :before-close="handleToClose" :close-on-click-modal="false">
                    <el-form ref="addForm" :model="addForm" label-width="80px" :rules="rules">
                        <el-form-item label="配置类型" prop="dicType">
                            <el-select v-model="addForm.dicType" placeholder="请选择配置类型">
                                            <el-option
                                            v-for="item in dictionaryArr"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                            </el-option>
                                        </el-select>
                        </el-form-item>
                        <el-form-item label="配置内容" prop="dicName">
                            <el-input v-model="addForm.dicName" placeholder="请输入配置内容"></el-input>
                        </el-form-item>
                        <el-form-item label="配置代码" prop="dicCode">
                            <el-input v-model="addForm.dicCode" placeholder="请输入配置代码"></el-input>
                        </el-form-item>
                        <div class="dialog-footer">
                            <el-button type="info" @click="handleToClose">取消</el-button>
                            <el-button type="primary" @click="submitForm()">确定</el-button>
                        </div>
                    </el-form>
                </el-dialog>
            </div>
        </el-container>
    </el-container>
</template>
<script>
export default {
    data() {
      return {
        addDialogVisible: false,
        tableIndex: 1,
        tableData: '',
        searchInput: '',
        // 查询参数
        searchInfo: {
            // 默认请求第一页
            pageNum: 1,
            // 默认请求10条数据
            pageSize: 10,
            //内容
            dicName: ''
        },
        // 数据列表
        tableData: [],
        // 数据总数
        total: 0,
        dialogVisible: false,
        addForm: {
                dicName: '',
                dicCode: '',
                dicType: ''
            },
            dictionaryArr: [
                {
                    value: 1,
                    label: '服装类型'
                },
                {
                    value: 2,
                    label: '服装材质'
                },
                {
                    value: 3,
                    label: '品牌商'
                },
                 {
                    value: 4,
                    label: '尺码'
                }
            ],
            rules: {
                 dicType: [
                     { required: true, message: '请选择配置类型', trigger: 'change' }
                 ],
                 dicName: [
                     { required: true, message: '请输入配置内容', trigger: 'blur' }
                 ],
                 dicCode: [
                     { required: true, message: '请输入配置代码', trigger: 'blur' }
                 ]
            }
      }
    },
    created() {
        // 获取数据列表
        this.searchClothesDictionary(1);
    },
    methods: {
        search() {
            this.searchInfo.pageNum = 1;
            this.searchClothesDictionary(this.tableIndex);
        },
        openDialog() {
            this.addDialogVisible= true;
        },
        async changeInUse(id) {
            const res = await this.$axios.post('manage/cloth/changeClothesDictionary',{
                id: id
            });
            if (res.data.code == 0) {
                this.$message.success(res.data.data);
                this.searchClothesDictionary(this.tableIndex);
            }else{
                this.$message.error(`${res.data.msg}`);
            }
        },
        async deleteClothesDictionary(id) {
            this.$confirm('确定要删除吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$axios
                    .get('manage/cloth/deleteClothesDictionary', {
                        params : {
                            id: id
                        }
                    })
                    .then(res => {
                        if (res.data.code == 0) {
                            this.$message.success('删除成功');
                            this.searchClothesDictionary(this.tableIndex);
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    })
                    .catch(() => {
                        this.searchClothesDictionary(this.tableIndex);
                    });
            });
        },
        async searchClothesDictionary(type) {
            this.tableIndex = type
            const res = await this.$axios.post('manage/cloth/searchClothesDictionary',{
                pageNum: this.searchInfo.pageNum,
                pageSize: this.searchInfo.pageSize,
                dicType: this.tableIndex
            });
            console.log(res);
            if (res.data.code == 0) {
                this.tableData = res.data.data;
                this.total = res.data.total;
            }else{
                this.$message.error(`${res.data.msg}`);
            }
        },
        submitForm() {
            let that = this;
            that.$refs.addForm.validate(valid => {
                if (valid) {
                    this.$axios
                        .post('manage/cloth/saveClothesDictionary', {
                            dicName: that.addForm.dicName,
                            dicCode: that.addForm.dicCode, 
                            dicType: that.addForm.dicType
                        })
                        .then(res => {
                            if (res.data.code == 0) {
                                //新增成功后 置空表单数据 关闭弹窗  刷新列表
                                that.$message.success('新增成功');
                                that.addDialogVisible = false;
                                that.searchClothesDictionary(this.tableIndex);
                                that.resetForm();
                            } else {
                                that.$message.error(res.data.data);
                            }
                        });
                } else {
                    // console.log('error submit!!');
                    return false;
                }
            });
        },
        resetForm() {
            this.$refs.addForm.resetFields();
        },
        handleToClose() {
            let that = this;
            that.$confirm('确认放弃对当前页面信息的保存吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            })
                .then(() => {
                    that.$refs.addForm.resetFields();
                    this.addDialogVisible = false;
                })
                .catch(() => {});
            // 重置表单
        },
        handleSizeChange(pageSize) {
            this.pageNum = 1;
            this.searchInfo.pageSize = pageSize;
            this.searchClothesDictionary(this.tableIndex);
        },

        handleCurrentChange(pageNum) {
            this.searchInfo.pageNum = pageNum;
            this.searchClothesDictionary(this.tableIndex);
        },

        handleToSearch() {
            this.searchInfo.pageNum = 1;
            this.searchClothesDictionary(this.tableIndex);
        },
        handleClosePwd() {
                    this.dialogVisible = false;
                }
    }
}
</script>

<style>
.dialog-footer {
    text-align: right;
}
.el-select {
    width: 100%;
}
  .el-header {
    line-height: 70px;
  }
  
  .el-aside {
    color: #333;
  }
</style>